import ProductCard from '../components/ProductCard';
import ZabihaPromise from '../components/ZabihaPromise';
import { HalalSeal, OrnateDivider, BananaLeaf } from '../components/KeralaDecor';
import { useWhatsApp } from '../context/WhatsAppContext';
import products from '../data/products';
import site from '../data/site';
import './MarketPage.css';

export default function MarketPage() {
  const { open } = useWhatsApp();

  return (
    <main className="market-page">
      {/* Hero */}
      <section className="market-hero">
        <div
          className="market-hero__pattern"
          aria-hidden="true"
          style={{ backgroundImage: 'url(/decor/leaf-pattern-tile.svg)' }}
        ></div>
        <BananaLeaf position="top-left" size={260} opacity={0.45} />
        <BananaLeaf position="bottom-right" size={260} opacity={0.45} mirror />
        <div className="container market-hero__inner">
          <div className="market-hero__seal">
            <HalalSeal size={140} />
          </div>
          <span className="eyebrow-script">Hand-cut. Zabiha. Fresh.</span>
          <h1 className="market-hero__title">The Halal Meat Market</h1>
          <OrnateDivider />
          <p className="market-hero__lead">
            A real butcher counter. Honest cuts, certified sourcing, restocked all week.
          </p>
          <div className="market-hero__cta">
            <a href={site.address.mapsUrl} target="_blank" rel="noopener noreferrer" className="btn btn-gold">Visit the Counter</a>
            <a href={`tel:${site.phones[0].tel}`} className="btn btn-ghost">📞 Call to Order</a>
          </div>
        </div>
      </section>

      <ZabihaPromise />

      {/* Product grid */}
      <section className="market-grid">
        <div className="container">
          <div className="market-grid__head">
            <span className="eyebrow-script">From Our Counter</span>
            <h2>Categories</h2>
            <p>Walk in to browse, or call to place an order ahead.</p>
          </div>
          <div className="market-grid__items">
            {products.map((p) => (
              <ProductCard key={p.slug} product={p} />
            ))}
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="market-how">
        <div
          className="market-how__pattern"
          aria-hidden="true"
          style={{ backgroundImage: 'url(/decor/leaf-pattern-tile.svg)' }}
        ></div>
        <div className="container market-how__inner">
          <span className="eyebrow-script">How It Works</span>
          <h2>From Our Hands to Yours</h2>
          <ol className="market-how__steps">
            <li>
              <span className="market-how__num">1</span>
              <h3>Call or Visit</h3>
              <p>Tell us what you need: cuts, marinades, sizes. We'll have it ready or cut it on the spot.</p>
            </li>
            <li>
              <span className="market-how__num">2</span>
              <h3>We Hand-Cut</h3>
              <p>Honest weight, careful trim. Zabiha hand-cut by people who care how it gets to your kitchen.</p>
            </li>
            <li>
              <span className="market-how__num">3</span>
              <h3>Pick Up Fresh</h3>
              <p>Same-day pickup. Restocked all week so what's on the case today was on the truck this morning.</p>
            </li>
          </ol>

          <div className="market-how__cta">
            <a href={`tel:${site.phones[0].tel}`} className="btn btn-gold">📞 {site.phones[0].display}</a>
            <a href={`tel:${site.phones[1].tel}`} className="btn btn-forest">📞 {site.phones[1].display}</a>
            <button onClick={open} className="btn btn-whatsapp">📱 Join WhatsApp</button>
          </div>
        </div>
      </section>
    </main>
  );
}
